import { render } from "./AddCard.vue?vue&type=template&id=26a0e021"
import script from "./AddCard.vue?vue&type=script&lang=js"
export * from "./AddCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__